/**
 * Formats of preview artefacts derived from media (produced and cached by the app's media layer).
 */
import { z } from 'zod';

/** Layout of a horizontal filmstrip sprite. */
export const FilmstripInfoSchema = z.object({
  /** Number of tiles in the horizontal sprite. */
  count: z.number().int().positive(),
  /** Seconds between tiles. */
  interval: z.number().positive(),
  tileWidth: z.number().int().positive(),
  tileHeight: z.number().int().positive(),
});
export type FilmstripInfo = z.infer<typeof FilmstripInfoSchema>;

/** Audio peak envelope for drawing waveforms. */
export const WaveformSchema = z.object({
  /** Peak buckets per second. */
  rate: z.number().positive(),
  peaks: z.array(z.number().int().min(0).max(255)),
});
export type Waveform = z.infer<typeof WaveformSchema>;
